// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"56":"badge-lib","3182":"react-highlight-words-frameless","5200":"wix-i18n-config_intl-pluralrules","6894":"wix-i18n-config_intl-relativetimeformat","7583":"member-card-async-frameless"}[chunkId] || chunkId) + ".chunk.min.js";
};